const scopes = [
  'https://graph.microsoft.com/Calendars.ReadWrite',
  'User.ReadBasic.All',
  'https://graph.microsoft.com/MailboxSettings.Read',
];

export const getToken = async (instance) => {
  const activeAccount = instance.getActiveAccount();
  try {
    const { accessToken } = await instance.acquireTokenSilent({
      scopes: scopes,
      account: activeAccount,
    });
    return accessToken;
  } catch (error) {
    const { accessToken } = await instance.acquireTokenPopup({
      scopes: scopes,
    });
    return accessToken;
  }
};
